<template>
  <div class="tab-list">
    <div class="tab">
      <div
        v-for="(item, key) in typeList"
        :key="key"
        class="tab__item"
        :class="getTabClass(key, item)"
        @click="changeTab(item)"
      >
        <div class="image"></div>
        <div class="tab__seperator" v-if="key != typeList.length - 1"></div>
      </div>
    </div>
    <div class="list">
      <template v-if="loading">
        <loader width="100%" height="40vw" background="transparent" />
      </template>
      <template v-else-if="newsList.length > 0">
        <div
          v-for="(item, key) in newsList"
          :key="key"
          class="list__item"
        >
          <div class="content">
            <div class="tag">{{ item.tag }}</div>
            <div class="title" @click="viewNews(item)">{{ item.title }}</div>
            <div class="time">{{ item.time }}</div>
          </div>
        </div>
        <div class="btn-more" @click="viewMore" v-if="total > 5">加载更多</div>
      </template>
      <template v-else>
        <div class="empty">暂无数据</div>
      </template>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/loader/Index.vue'

import { getNewsData } from '@/api/system.api.js'

export default {
  components: {
    Loader,
  },
  data() {
    return {
      activeTab: 'last',
      typeList: {},
      newsList: [],
      total: 0,
      currentPage: 1,
      loading: false
    }
  },
  created() {
    this.getNewsList()
  },
  methods: {
    async getNewsList() {
      this.typeList = [
        "last",
        "news",
        "strategy",
        "activity",
      ]
      this.loading = true
      const data = await this.getListByType(this.activeTab)
      this.loading = false
      this.newsList = data.list
      this.total = data.total
    },
    async getListByType(type) {
      const list = await getNewsData({
        page: this.currentPage,
        limit: 10,
      }, type)
        .then((res) => {
          let list = []
          for (let i = 0; i < res.list.length; i++) {
            list.push({
              id: res.list[i].id,
              tag: res.list[i].tag,
              title: res.list[i].title,
              time: new Date(res.list[i].createtime * 1000).toLocaleDateString('zh-cn'),
              description: res.list[i].desc,
            })
          }

          return {
            list: list,
            total: res.total,
          }
        })
        .catch(() => {
          return {
            list: [],
            total: 0,
          }
        })

      return list
    },
    // 获取当前选中的新闻类型的className
    getTabClass(key, item) {
      let className = 'tab__type-' + item

      return className + (this.activeTab == item ? ' tab--active' : '')
    },
    // 切换分类
    changeTab(key) {
      this.newsList = []
      this.activeTab = key
      this.currentPage = 1
      this.getNewsList()
    },
    // 跳转到新闻详情页
    viewNews(item) {
      this.$router.push({ name: 'MobileNews', query: { id: item.id } })
    },
    viewMore() {
      this.currentPage++
      this.getNewsList()
    },
  }
}
</script>

<style lang="scss" scoped>
.tab-list {
  padding: 0 4.8vw 12.533333vw;
}

.tab {
  position: relative;
  display: flex;
  justify-content: center;
  margin: 5.866666vw auto 1.733333vw;

  &__item {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    cursor: pointer;

    .image {
      width: 13.6vw;
      height: 7.733333vw;
      background: url('~@/assets/img/mobile/news_type.png') no-repeat;
      background-size: 100% 30.933333vw;
    }
  }

  &--active {
    background: url('~@/assets/img/pc/news_type_active.png') no-repeat;
    background-size: 13.6vw;
    background-position: left bottom;
  }

  &__seperator {
    transform: rotate(45deg);
    margin-left: .8vw;
    width: 1.2vw;
    height: 1.2vw;
    background: #9a7b62;
  }

  &__type {
    &-latest .image {
      background-position: 0 0;
    }
    &-news .image {
      background-position: 0 -7.733333vw;
    }
    &-tips .image {
      background-position: 0 -15.466666vw;
    }
    &-activity .image {
      background-position: 0 -23.2vw;
    }
  }
}

.list {
  width: 100%;
  min-height: 66.666666vw;
  border-top: .133333vw solid #c3ad99;

  &__item {
    padding-top: 3.2vw;
    border-bottom: .133333vw solid #e8e1da;

    .content {
      display: flex;
      margin: 0 auto;
      width: 100%;
      height: 8.133333vw;
    }
    
    .tag {
      margin-right: .5vw;
      width: 8.533333vw;
      height: 4.8vw;
      text-align: center;
      line-height: 4.8vw;
      font-size: 3.2vw;
      color: #fff;
      background: #388176;
    }

    .title {
      flex: 1;
      margin-right: 2vw;
      height: 4.8vw;
      line-height: 4.8vw;
      font-size: 4vw;
      color: #584c45;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    
    .time {
      width: 15.6vw;
      font-size: 3vw;
      color: #978d88
    }
  }

  .empty {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40vw;
    font-size: 4vw;
    color: #3a3a3a;
  }
}

.btn-more {
  margin: 30vw auto 0;
  width: 40.133333vw;
  height: 8.8vw;
  text-align: center;
  line-height: 8.8vw;
  font-size: 3.466666vw;
  color: #388176;
  background: url('~@/assets/img/mobile/more_btn.png') no-repeat;
  background-size: 100%;
}
</style>